import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { environment } from '@environments/environment';

type EnvLabel = 'DEV' | 'QA';

function detectEnv(): EnvLabel | null {
  switch (true) {
    case environment.portalDomain?.includes('dev.np-saas.'):
      return 'DEV';
    case environment.portalDomain?.includes('qa.np-saas.'):
      return 'QA';
    default:
      return null;
  }
}

@Component({
  selector: 'app-environment-banner',
  standalone: true,
  imports: [CommonModule, TranslocoDirective],
  templateUrl: './environment-banner.component.html',
  styleUrls: ['./environment-banner.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentBannerComponent {
  readonly envLabel: EnvLabel | null = detectEnv();
}
